// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-editor-form .form-group {
  margin-left: 5px;
  min-width: 140px;
}

.dashboard-back-btn {
  position: absolute;
  right: 98px;
}

.dashboard .flippy-back {
  margin-top: 0% !important;
  padding: 0px !important;
}

.dashboard .flippy-front {
  margin-top: 0% !important;
  padding: 0px !important;
}

.dashboard-filter-btn {
  position: absolute;
  right: 2px;
}

.dashboard-save-btn {
  position: absolute;
  right: 50px;
}

.dashboard .btn-primary {
  color: #fff;
  background-color: #265160;
  border-color: #265160;
}

.dashboard .btn-primary:hover {
  background-image: none !important;
  background-color: rgba(38, 81, 96, 0.768627451) !important;
}

.dashboard .deactivateDash .react-switch-bg {
  background: rgb(39, 83, 98) !important;
}

.dashboard .react-switch-handle {
  background: #fff !important;
}

.create-filter-form {
  flex-direction: column;
  padding: 5px 5px 0 5px;
  background: white;
  display: flex;
  flex: 1;
}

.create-filter-form .btn {
  bottom: 0px;
  right: 0px;
  position: absolute;
}

.hide-dash-editor {
  display: none;
}

.dates-container {
  display: flex;
  gap: 1rem;
}

.react-datepicker-wrapper {
  padding-right: 0px !important;
}

.dashboard-filter-field {
  min-width: 15px;
  margin-right: 0px;
  margin-bottom: 5px;
}

.dashboard-filter-field .form-checkbox {
  width: 20px;
  height: 20px;
}

.dates-container input,
.create-filter-form input {
  display: block;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 12vw;
}

.dates-container input {
  width: 140px;
}

#filtertype {
  max-width: 23vw;
}

div.filter-form-container,
div.comments-modal-container {
  background: white;
  border-radius: 10px;
  margin-top: 5px;
  box-shadow: -3px 3px 18px #cccccc;
}

div.comments-modal-container.show-filter-panel {
  height: 82vh !important;
  max-height: 82vh !important;
  overflow-y: hidden !important;
}

div.filter-form-container.show-filter-panel,
div.comments-modal-container.show-filter-panel {
  background: white;
  border-radius: 5px;
  margin-top: 5px;
  box-shadow: -3px 3px 18px #cccccc;
  overflow-y: scroll;
  height: 70vh;
  position: absolute;
  z-index: 10000;
  right: 0;
  top: 0;
  transition: 0.8s ease-in;
}

.disappear {
  display: none;
}

.blurOut {
  display: block;
  filter: blur(5px);
  pointer-events: none;
}

#filtereditor-form-container button.close,
.filter-form-container button.close,
.comments-modal-container button.close {
  background-color: transparent;
  border-radius: none;
}

#filtereditor-form-container label,
.filter-form-container label,
.comments-modal-container label {
  color: #275362;
}

#filtereditor-form-container {
  background-color: white;
  border-radius: 10px;
  margin-top: 60px;
}

.apply-filter-btn-wrapper {
  display: flex;
  margin: 10px auto;
  padding-bottom: 10px;
}

.apply-filter-btn {
  border-radius: 0px;
  margin-left: 0px;
  flex: 1;
}

.custom-react-select-container {
  height: auto;
  padding: 8px 12px;
  display: flex;
  box-shadow: 0px 0px 5px 0px grey;
}

.custom-react-select-container:hover {
  background-color: #deebff !important;
  width: 100%;
}

.custom-react-select-container i {
  margin-left: auto;
}

.dash-manager-bar {
  padding-top: 2px !important;
  padding-bottom: 0px;
  position: relative;
  width: auto;
  float: right;
  right: 0;
}

.dashboard-viewer-div {
  position: relative;
  float: left;
  width: 100%;
}

.dashboard-header-container {
  width: 100%;
  float: left;
  background-color: #275362;
}

.dashboard-label-text {
  padding: 2px;
  color: white;
  font-weight: bold;
  font-size: x-large;
  float: left;
  margin-top: 6px;
}

.react-select-container {
  z-index: 100;
  width: 300px;
  float: left;
  right: 10px;
}

.dash-manager-buttons .btn {
  margin-right: 7px;
  border-color: #c5d2d6 !important;
}

.dash-manager-buttons {
  right: 0px;
  width: auto;
  float: right;
  position: relative;
}

.dash-manager-buttons .btn.btn-primary {
  color: #345561;
  background-color: #e4e7eb;
  border-radius: 50%;
  font-size: 13px !important;
  border: none;
  box-shadow: 0px 2px 4px 2px lightgrey;
  margin-bottom: 4px;
}

.dash-manager-buttons .btn.btn-primary:hover {
  color: #345561;
  border-color: #c7cdd5;
  background-color: #c5d2d6 !important;
}

.dasboard-viewer-wrapper {
  display: flex;
  flex-direction: column;
}
.dasboard-viewer-wrapper .dashboard-drilldown-info-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 0px;
  justify-content: flex-start;
  margin: 5px 0 0 0;
}

.dasboard-viewer-content {
  background-color: #ffffff;
  border: none;
  border-radius: 0;
  box-shadow: none;
  min-width: 100%;
  margin-top: 13px;
}

.dashboard-rollup-button {
  color: white;
  cursor: pointer;
  background-color: rgb(39, 83, 98);
  overflow: hidden;
  padding: 0px !important;
  border-radius: 0;
  margin-left: auto;
}

.dashboard-filter-description {
  height: 32px;
  width: 100%;
  font-size: 15px !important;
  border-radius: 0 !important;
}

.dashboard-preview-tab {
  background-image: linear-gradient(to right, #275362, #235764, #205b65, #1d5f65, #1d6365);
  height: 1.3em;
  color: #f2f2f2;
  top: 50%;
  width: 15em;
  text-align: center;
}

.dashboard-preview-tab span {
  position: relative;
  top: 0.1em;
}

.create-dash-btn {
  margin-left: 1em;
  margin-bottom: 10px;
}

.Window_Analytics .dashboard .GridCustomStyle {
  height: calc(100% - 91px) !important;
}

.Window_Analytics .dashboard label {
  color: #265160 !important;
}

.dashboard-container {
  margin-top: 4em;
}

.k-grid-header .k-i-sort-asc-sm,
.k-grid-header .k-i-sort-desc-sm,
.k-grid-header .k-sort-order {
  color: #656565 !important;
}

.k-grid-header .k-grid-filter.k-state-active,
.k-grid-header .k-header-column-menu.k-state-active,
.k-grid-header .k-hierarchy-cell .k-icon.k-state-active {
  color: #fff;
  background-color: #656565 !important;
}

.k-pager-numbers .k-link.k-state-selected {
  color: #656565 !important;
  background-color: rgba(78, 73, 73, 0.2) !important;
}

.k-pager-numbers .k-link {
  color: #656565 !important;
}

.k-pager-numbers .k-link:hover,
.k-pager-numbers .k-link.k-state-hover {
  color: #656565 !important;
  background-color: rgba(78, 73, 73, 0.2) !important;
}

/*
  With discussion with Harsha, Vinu and UV:
  Whenever there is a drilldown grid
  The solutions provided is we can mark the first cell of all rows blue and underline,
  so they know that know its a link
*/
.drillDownStyle table tr:not(.k-grid-norecords) td:first-child {
  color: blue;
  text-decoration: underline;
}

.drillDownStyle .k-master-row:hover {
  color: blue !important;
  text-decoration: underline;
  cursor: pointer !important;
}

.filter_remove_button {
  cursor: pointer;
  float: left;
  vertical-align: middle;
  margin-top: 25px;
  position: relative;
  margin-left: 10px;
}

.filter_remove_button_view,
.filter_remove_button_view.btn.btn-primary {
  cursor: pointer;
  position: relative;
  margin: 0;
  padding: 2px 7px;
}

.errorMsg {
  color: red !important;
}

.dashboard-filter-field {
  font-size: 13px;
}

.dashboardTextField {
  font-size: 13px !important;
  height: 38px !important;
}

.field-width-75 {
  width: 75px !important;
}

.field-width-100 {
  width: 100px !important;
}

.field-width-150 {
  width: 150px !important;
}

.field-width-200 {
  width: 200px !important;
}

.field-width-300 {
  width: 300px !important;
}

.select_notif {
  padding: 4px;
  color: red;
  font-size: 12px;
  margin-top: 0px;
}

.toastHide {
  visibility: hidden;
}

.full-width {
  widows: 100%;
  overflow: hidden;
}

.filterFieldsfilter {
  display: inline-block;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
  box-shadow: 4px 4px 10px #ebebeb, -4px -4px 10px rgba(234, 234, 234, 0.7098039216);
  margin-bottom: 10px;
  padding: 0 5px;
}

.dashboard-filter-wrapper {
  display: flex;
  flex-direction: column;
  padding: 10px;
  right: 10px;
  z-index: 11;
  position: relative;
  width: 450px;
  background-color: white;
  box-shadow: 1px 5px 10px lightgray;
  padding: 10px 50px;
  border-radius: 15px;
  height: 89vh;
}
.dashboard-filter-wrapper .filter-header-panel {
  display: flex;
  flex: 0;
  align-items: center;
  border-bottom: 1px solid lightgrey;
  padding-bottom: 5px;
}
.dashboard-filter-wrapper .filter-header-panel .filter-header-text {
  font-size: 24px;
  color: #5d6d80;
  margin-bottom: 0;
}

.dashboard-filter-wrapper-viewer {
  display: flex;
  align-items: end;
  flex-direction: column;
  position: fixed;
  right: 70px;
  height: 350px;
  overflow-y: scroll;
  top: 8%;
  z-index: 11;
  width: 503px;
  background-color: white;
  box-shadow: 1px 5px 10px lightgray;
  padding: 10px 25px;
  border-radius: 15px;
}

.dashboard-filter-name {
  letter-spacing: 1px;
  flex-basis: 50%;
  font-size: 16px;
  color: #275362;
  padding: 5px;
  border-radius: 5px;
}

.filter-form-container .filterFieldsfilter .filterFieldsfilter-section-one,
.comments-modal-container .filterFieldsfilter .filterFieldsfilter-section-one {
  display: flex;
  align-items: center;
  flex-basis: 100%;
  gap: 10px;
}
.filter-form-container .filterFieldsfilter .filterFieldsfilter-section-one .dashboardTextField,
.comments-modal-container .filterFieldsfilter .filterFieldsfilter-section-one .dashboardTextField {
  flex-basis: 100%;
}
.filter-form-container .filterFieldsfilter .filterFieldsfilter-section-one select.dashboardTextField.form-control,
.comments-modal-container .filterFieldsfilter .filterFieldsfilter-section-one select.dashboardTextField.form-control {
  border: none;
}
.filter-form-container .filterFieldsfilter .filterFieldsfilter-section-one #value.dashboardTextField,
.comments-modal-container .filterFieldsfilter .filterFieldsfilter-section-one #value.dashboardTextField {
  flex-basis: 100%;
}
.filter-form-container .filterFieldsfilter .filterFieldsfilter-section-two,
.comments-modal-container .filterFieldsfilter .filterFieldsfilter-section-two {
  flex: 1 0 100%;
}
.filter-form-container .filterFieldsfilter .filterFieldsfilter-section-two .dashboard-filter-field,
.comments-modal-container .filterFieldsfilter .filterFieldsfilter-section-two .dashboard-filter-field {
  display: flex;
  justify-content: center;
}
.filter-form-container .filterFieldsfilter .filterFieldsfilter-section-two #value.dashboardTextField,
.comments-modal-container .filterFieldsfilter .filterFieldsfilter-section-two #value.dashboardTextField {
  flex-basis: 100%;
}

.comments-modal-container .dash-manager-buttons {
  padding: 15px 15px 0px 15px;
  width: 100%;
}
.comments-modal-container .commentsPage {
  overflow-y: hidden !important;
}
.comments-modal-container .commentsPage #chat-container {
  width: 100% !important;
  overflow-y: scroll;
  max-height: 55%;
}
.comments-modal-container .commentsPage .no-comments-found {
  max-height: 55%;
}
.comments-modal-container .commentsPage #emoji-list {
  right: 3rem;
}
.comments-modal-container .commentsPage #emoji-list .emoji-mart {
  width: 283px !important;
  font-size: 14px !important;
  margin-top: 10px;
}

#filtereditor-form-container .create-filter-form {
  display: flex;
  justify-content: flex-start;
}
#filtereditor-form-container .create-filter-form > .filterFields.form-row {
  margin: 10px 0px;
  padding: 5px;
  box-shadow: 4px 4px 10px #ebebeb, -4px -4px 10px rgba(234, 234, 234, 0.7098039216);
  gap: 5px;
  align-items: center;
}
#filtereditor-form-container .create-filter-form > .filterFields.form-row .filterFieldsfilter-section-two {
  flex: 1;
  align-self: flex-end;
}
#filtereditor-form-container .create-filter-form > .filterFields.form-row .filterFieldsfilter-section-two > .dashboard-filter-field {
  flex: 1;
}
#filtereditor-form-container .create-filter-form > .filterFields.form-row .filterFieldsfilter-section-two #value.dashboardTextField {
  flex-basis: 0;
}
#filtereditor-form-container .create-filter-form > .filterFields.form-row .filterFieldsfilter-section-two .dates-container {
  display: inline-block;
}
#filtereditor-form-container .create-filter-form > .filterFields.form-row .dash-manager-buttons {
  display: flex;
  align-items: flex-end;
  margin-left: auto;
  align-self: flex-end;
}

input[type=checkbox] {
  height: 12px;
  width: 12px;
}`, "",{"version":3,"sources":["webpack://./../gui/src/public/css/dashboardEditor.scss","webpack://./../gui/src/public/css/variables.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;AADF;;AAIA;EACE,yBAAA;EACA,uBAAA;AADF;;AAIA;EACE,yBAAA;EACA,uBAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;AADF;;AAIA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AADF;;AAIA;EACE,iCAAA;EACA,0DAAA;AADF;;AAIA;EACE,sCAAA;AADF;;AAIA;EACE,2BAAA;AADF;;AAKA;EACE,sBAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,OAAA;AAFF;;AAKA;EACE,WAAA;EACA,UAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,aAAA;EACA,SAAA;AAFF;;AAKA;EACE,6BAAA;AAFF;;AAKA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAKA;;EAEE,cAAA;EACA,mCAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,sBAAA;EACA,wEACE;EAEF,WAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;;EAEE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,iCAAA;AAJF;;AAOA;EACE,uBAAA;EACA,2BAAA;EACA,6BAAA;AAJF;;AAOA;;EAEE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,MAAA;EACA,wBAAA;AAJF;;AAOA;EACE,aAAA;AAJF;;AAOA;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;AAJF;;AAOA;;;EAGE,6BAAA;EACA,mBAAA;AAJF;;AAOA;;;EAGE,cAAA;AAJF;;AAOA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,aAAA;EACA,iBAAA;EACA,oBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,OAAA;AAJF;;AAOA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,gCAAA;AAJF;;AAOA;EACE,oCAAA;EACA,WAAA;AAJF;;AAOA;EAGE,iBAAA;AANF;;AASA;EACE,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;AANF;;AASA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AANF;;AASA;EACE,WAAA;EACA,WAAA;EACA,yBAAA;AANF;;AASA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AANF;;AASA;EACE,YAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AANF;;AASA;EACE,iBAAA;EACA,gCAAA;AANF;;AASA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AANF;;AASA;EACE,cC5Pa;ED6Pb,yBC5PwB;ED6PxB,kBAAA;EACA,0BAAA;EACA,YAAA;EACA,qCAAA;EAGA,kBAAA;AARF;;AAWA;EACE,cCxQa;EDyQb,qBCnQ0B;EDoQ1B,oCAAA;AARF;;AAWA;EACE,aAAA;EACA,sBAAA;AARF;AAUE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;AARJ;;AAYA;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AATF;;AAaA;EACE,YAAA;EACA,eAAA;EACA,iCAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AAVF;;AAaA;EAIE,YAAA;EACA,WAAA;EACA,0BAAA;EACA,2BAAA;AAbF;;AAgBA;EACE,wFAAA;EACA,aAAA;EACA,cAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,UAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,oCAAA;AAbF;;AAgBA;EACE,yBAAA;AAbF;;AAgBA;EACE,eAAA;AAbF;;AAgBA;;;EAGE,yBAAA;AAbF;;AAgBA;;;EAGE,WAAA;EACA,oCAAA;AAbF;;AAgBA;EACE,yBAAA;EACA,kDAAA;AAbF;;AAgBA;EACE,yBAAA;AAbF;;AAgBA;;EAEE,yBAAA;EACA,kDAAA;AAbF;;AAgBA;;;;;CAAA;AAMA;EACE,WAAA;EACA,0BAAA;AAbF;;AAgBA;EACE,sBAAA;EACA,0BAAA;EACA,0BAAA;AAbF;;AAgBA;EACE,eAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAbF;;AAgBA;;EAEE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,qBAAA;AAbF;;AAgBA;EACE,eAAA;AAbF;;AAgBA;EACE,0BAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,sBAAA;AAbF;;AAgBA;EACE,uBAAA;AAbF;;AAgBA;EACE,uBAAA;AAbF;;AAgBA;EACE,uBAAA;AAbF;;AAgBA;EACE,uBAAA;AAbF;;AAgBA;EACE,YAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;AAbF;;AAmBA;EACE,kBAAA;AAhBF;;AAmBA;EACE,YAAA;EACA,gBAAA;AAhBF;;AAmBA;EAEE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EAGA,kFACE;EAEF,mBAAA;EACA,cAAA;AArBF;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,kCAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AArBF;AAuBE;EACE,aAAA;EACA,OAAA;EACA,mBAAA;EACA,kCAAA;EACA,mBAAA;AArBJ;AAuBI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AArBN;;AA0BA;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kCAAA;EACA,kBAAA;EACA,mBAAA;AAvBF;;AA0BA;EACE,mBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AAvBF;;AA+BI;;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AA3BN;AA6BM;;EACE,gBAAA;AA1BR;AA6BM;;EACE,YAAA;AA1BR;AA6BM;;EACE,gBAAA;AA1BR;AA8BI;;EACE,cAAA;AA3BN;AA6BM;;EACE,aAAA;EACA,uBAAA;AA1BR;AA6BM;;EACE,gBAAA;AA1BR;;AAiCE;EACE,2BAAA;EACA,WAAA;AA9BJ;AAiCE;EACE,6BAAA;AA/BJ;AAiCI;EACE,sBAAA;EACA,kBAAA;EACA,eAAA;AA/BN;AAkCI;EACE,eAAA;AAhCN;AAmCI;EACE,WAAA;AAjCN;AAmCM;EACE,uBAAA;EACA,0BAAA;EACA,gBAAA;AAjCR;;AAyCE;EACE,aAAA;EACA,2BAAA;AAtCJ;AAwCI;EACE,gBAAA;EACA,YAAA;EACA,kFACE;EAEF,QAAA;EACA,mBAAA;AAxCN;AA0CM;EACE,OAAA;EACA,oBAAA;AAxCR;AA0CQ;EACE,OAAA;AAxCV;AA2CQ;EACE,aAAA;AAzCV;AA4CQ;EACE,qBAAA;AA1CV;AA8CM;EACE,aAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;AA5CR;;AAkDA;EAEE,YAAA;EACA,WAAA;AAhDF","sourcesContent":["@import \"./variables.scss\";\n\n.dashboard-editor-form .form-group {\n  margin-left: 5px;\n  min-width: 140px;\n}\n\n.dashboard-back-btn {\n  position: absolute;\n  right: 98px;\n}\n\n.dashboard .flippy-back {\n  margin-top: 0% !important;\n  padding: 0px !important;\n}\n\n.dashboard .flippy-front {\n  margin-top: 0% !important;\n  padding: 0px !important;\n}\n\n.dashboard-filter-btn {\n  position: absolute;\n  right: 2px;\n}\n\n.dashboard-save-btn {\n  position: absolute;\n  right: 50px;\n}\n\n.dashboard .btn-primary {\n  color: #fff;\n  background-color: #265160;\n  border-color: #265160;\n}\n\n.dashboard .btn-primary:hover {\n  background-image: none !important;\n  background-color: #265160c4 !important;\n}\n\n.dashboard .deactivateDash .react-switch-bg {\n  background: rgb(39, 83, 98) !important;\n}\n\n.dashboard .react-switch-handle {\n  background: #fff !important;\n}\n\n//dashboard editor filter\n.create-filter-form {\n  flex-direction: column;\n  padding: 5px 5px 0 5px;\n  background: white;\n  display: flex;\n  flex: 1;\n}\n\n.create-filter-form .btn {\n  bottom: 0px;\n  right: 0px;\n  position: absolute;\n}\n\n.hide-dash-editor {\n  display: none;\n}\n\n.dates-container {\n  display: flex;\n  gap: 1rem;\n}\n\n.react-datepicker-wrapper {\n  padding-right: 0px !important;\n}\n\n.dashboard-filter-field {\n  min-width: 15px;\n  margin-right: 0px;\n  margin-bottom: 5px;\n}\n\n.dashboard-filter-field .form-checkbox {\n  width: 20px;\n  height: 20px;\n}\n\n.dates-container input,\n.create-filter-form input {\n  display: block;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition:\n    border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n  width: 12vw;\n}\n\n.dates-container input {\n  width: 140px;\n}\n\n#filtertype {\n  max-width: 23vw;\n}\n\ndiv.filter-form-container,\ndiv.comments-modal-container {\n  background: white;\n  border-radius: 10px;\n  margin-top: 5px;\n  box-shadow: -3px 3px 18px #cccccc;\n}\n\ndiv.comments-modal-container.show-filter-panel {\n  height: 82vh !important;\n  max-height: 82vh !important;\n  overflow-y: hidden !important;\n}\n\ndiv.filter-form-container.show-filter-panel,\ndiv.comments-modal-container.show-filter-panel {\n  background: white;\n  border-radius: 5px;\n  margin-top: 5px;\n  box-shadow: -3px 3px 18px #cccccc;\n  overflow-y: scroll;\n  height: 70vh;\n  position: absolute;\n  z-index: 10000;\n  right: 0;\n  top: 0;\n  transition: 0.8s ease-in;\n}\n\n.disappear {\n  display: none;\n}\n\n.blurOut {\n  display: block;\n  filter: blur(5px);\n  pointer-events: none;\n}\n\n#filtereditor-form-container button.close,\n.filter-form-container button.close,\n.comments-modal-container button.close {\n  background-color: transparent;\n  border-radius: none;\n}\n\n#filtereditor-form-container label,\n.filter-form-container label,\n.comments-modal-container label {\n  color: #275362;\n}\n\n#filtereditor-form-container {\n  background-color: white;\n  border-radius: 10px;\n  margin-top: 60px;\n}\n\n.apply-filter-btn-wrapper {\n  display: flex;\n  margin: 10px auto;\n  padding-bottom: 10px;\n}\n\n.apply-filter-btn {\n  border-radius: 0px;\n  margin-left: 0px;\n  flex: 1;\n}\n\n.custom-react-select-container {\n  height: auto;\n  padding: 8px 12px;\n  display: flex;\n  box-shadow: 0px 0px 5px 0px grey;\n}\n\n.custom-react-select-container:hover {\n  background-color: #deebff !important;\n  width: 100%;\n}\n\n.custom-react-select-container i {\n  // float: right;\n  // right: 0px;\n  margin-left: auto;\n}\n\n.dash-manager-bar {\n  padding-top: 2px !important;\n  padding-bottom: 0px;\n  position: relative;\n  width: auto;\n  float: right;\n  right: 0;\n}\n\n.dashboard-viewer-div {\n  position: relative;\n  float: left;\n  width: 100%;\n}\n\n.dashboard-header-container {\n  width: 100%;\n  float: left;\n  background-color: #275362;\n}\n\n.dashboard-label-text {\n  padding: 2px;\n  color: white;\n  font-weight: bold;\n  font-size: x-large;\n  float: left;\n  margin-top: 6px;\n}\n\n.react-select-container {\n  z-index: 100;\n  width: 300px;\n  float: left;\n  right: 10px;\n}\n\n.dash-manager-buttons .btn {\n  margin-right: 7px;\n  border-color: $button-border-color !important;\n}\n\n.dash-manager-buttons {\n  right: 0px;\n  width: auto;\n  float: right;\n  position: relative;\n}\n\n.dash-manager-buttons .btn.btn-primary {\n  color: $button-color;\n  background-color: $button-background-color;\n  border-radius: 50%;\n  font-size: 13px !important;\n  border: none;\n  box-shadow: 0px 2px 4px 2px lightgrey;\n\n  // padding: 7px 9px 7px 11px;\n  margin-bottom: 4px;\n}\n\n.dash-manager-buttons .btn.btn-primary:hover {\n  color: $button-color;\n  border-color: $button-border-color-hover;\n  background-color: $button-background-color-hover !important;\n}\n\n.dasboard-viewer-wrapper {\n  display: flex;\n  flex-direction: column;\n\n  .dashboard-drilldown-info-wrapper {\n    display: flex;\n    align-items: center;\n    position: relative;\n    margin-bottom: 0px;\n    justify-content: flex-start;\n    margin: 5px 0 0 0;\n  }\n}\n\n.dasboard-viewer-content {\n  background-color: #ffffff;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  min-width: 100%;\n  margin-top: 13px;\n  // margin-top: 4em;\n}\n\n.dashboard-rollup-button {\n  color: white;\n  cursor: pointer;\n  background-color: rgb(39, 83, 98);\n  overflow: hidden;\n  padding: 0px !important;\n  border-radius: 0;\n  margin-left: auto;\n}\n\n.dashboard-filter-description {\n  // position: absolute;\n  // left: 0;\n  // top: 0;\n  height: 32px;\n  width: 100%;\n  font-size: 15px !important;\n  border-radius: 0 !important;\n}\n\n.dashboard-preview-tab {\n  background-image: linear-gradient(to right, #275362, #235764, #205b65, #1d5f65, #1d6365);\n  height: 1.3em;\n  color: #f2f2f2;\n  top: 50%;\n  width: 15em;\n  text-align: center;\n}\n\n.dashboard-preview-tab span {\n  position: relative;\n  top: 0.1em;\n}\n\n.create-dash-btn {\n  margin-left: 1em;\n  margin-bottom: 10px;\n}\n\n.Window_Analytics .dashboard .GridCustomStyle {\n  height: calc(100% - 91px) !important;\n}\n\n.Window_Analytics .dashboard label {\n  color: #265160 !important;\n}\n\n.dashboard-container {\n  margin-top: 4em;\n}\n\n.k-grid-header .k-i-sort-asc-sm,\n.k-grid-header .k-i-sort-desc-sm,\n.k-grid-header .k-sort-order {\n  color: #656565 !important;\n}\n\n.k-grid-header .k-grid-filter.k-state-active,\n.k-grid-header .k-header-column-menu.k-state-active,\n.k-grid-header .k-hierarchy-cell .k-icon.k-state-active {\n  color: #fff;\n  background-color: #656565 !important;\n}\n\n.k-pager-numbers .k-link.k-state-selected {\n  color: #656565 !important;\n  background-color: rgba(78, 73, 73, 0.2) !important;\n}\n\n.k-pager-numbers .k-link {\n  color: #656565 !important;\n}\n\n.k-pager-numbers .k-link:hover,\n.k-pager-numbers .k-link.k-state-hover {\n  color: #656565 !important;\n  background-color: rgba(78, 73, 73, 0.2) !important;\n}\n\n/*\n  With discussion with Harsha, Vinu and UV:\n  Whenever there is a drilldown grid\n  The solutions provided is we can mark the first cell of all rows blue and underline,\n  so they know that know its a link\n*/\n.drillDownStyle table tr:not(.k-grid-norecords) td:first-child {\n  color: blue;\n  text-decoration: underline;\n}\n\n.drillDownStyle .k-master-row:hover {\n  color: blue !important;\n  text-decoration: underline;\n  cursor: pointer !important;\n}\n\n.filter_remove_button {\n  cursor: pointer;\n  float: left;\n  vertical-align: middle;\n  margin-top: 25px;\n  position: relative;\n  margin-left: 10px;\n}\n\n.filter_remove_button_view,\n.filter_remove_button_view.btn.btn-primary {\n  cursor: pointer;\n  position: relative;\n  margin: 0;\n  padding: 2px 7px;\n}\n\n.errorMsg {\n  color: red !important;\n}\n\n.dashboard-filter-field {\n  font-size: 13px;\n}\n\n.dashboardTextField {\n  font-size: 13px !important;\n  height: 38px !important;\n}\n\n.field-width-75 {\n  width: 75px !important;\n}\n\n.field-width-100 {\n  width: 100px !important;\n}\n\n.field-width-150 {\n  width: 150px !important;\n}\n\n.field-width-200 {\n  width: 200px !important;\n}\n\n.field-width-300 {\n  width: 300px !important;\n}\n\n.select_notif {\n  padding: 4px;\n  color: red;\n  font-size: 12px;\n  margin-top: 0px;\n  // background: rgba(255, 255, 0, 0.453);\n  // float: left;\n  // margin-bottom: 15px;\n}\n\n.toastHide {\n  visibility: hidden;\n}\n\n.full-width {\n  widows: 100%;\n  overflow: hidden;\n}\n\n.filterFieldsfilter {\n  //display: inline-flex !important;\n  display: inline-block;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n  // border-left: 2px solid #265160;\n  // border-bottom: 2px solid #27536296;\n  box-shadow:\n    4px 4px 10px #ebebeb,\n    -4px -4px 10px #eaeaeab5;\n  margin-bottom: 10px;\n  padding: 0 5px;\n}\n\n.dashboard-filter-wrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  right: 10px;\n  z-index: 11;\n  position: relative;\n  width: 450px;\n  background-color: white;\n  box-shadow: 1px 5px 10px lightgray;\n  padding: 10px 50px;\n  border-radius: 15px;\n  height: 89vh;\n\n  .filter-header-panel {\n    display: flex;\n    flex: 0;\n    align-items: center;\n    border-bottom: 1px solid lightgrey;\n    padding-bottom: 5px;\n\n    .filter-header-text {\n      font-size: 24px;\n      color: #5d6d80;\n      margin-bottom: 0;\n    }\n  }\n}\n\n.dashboard-filter-wrapper-viewer {\n  display: flex;\n  align-items: end;\n  flex-direction: column;\n  position: fixed;\n  right: 70px;\n  height: 350px;\n  overflow-y: scroll;\n  top: 8%;\n  z-index: 11;\n  width: 503px;\n  background-color: white;\n  box-shadow: 1px 5px 10px lightgray;\n  padding: 10px 25px;\n  border-radius: 15px;\n}\n\n.dashboard-filter-name {\n  letter-spacing: 1px;\n  flex-basis: 50%;\n  font-size: 16px;\n  color: #275362;\n  padding: 5px;\n  border-radius: 5px;\n  // margin-right: 1rem;\n}\n\n// View Mode - Filter Fields CSS\n.filter-form-container,\n.comments-modal-container {\n  .filterFieldsfilter {\n    .filterFieldsfilter-section-one {\n      display: flex;\n      align-items: center;\n      flex-basis: 100%;\n      gap: 10px;\n\n      .dashboardTextField {\n        flex-basis: 100%;\n      }\n\n      select.dashboardTextField.form-control {\n        border: none;\n      }\n\n      #value.dashboardTextField {\n        flex-basis: 100%;\n      }\n    }\n\n    .filterFieldsfilter-section-two {\n      flex: 1 0 100%;\n\n      .dashboard-filter-field {\n        display: flex;\n        justify-content: center;\n      }\n\n      #value.dashboardTextField {\n        flex-basis: 100%;\n      }\n    }\n  }\n}\n\n.comments-modal-container {\n  .dash-manager-buttons {\n    padding: 15px 15px 0px 15px;\n    width: 100%;\n  }\n\n  .commentsPage {\n    overflow-y: hidden !important;\n\n    #chat-container {\n      width: 100% !important;\n      overflow-y: scroll;\n      max-height: 55%;\n    }\n\n    .no-comments-found {\n      max-height: 55%;\n    }\n\n    #emoji-list {\n      right: 3rem;\n\n      .emoji-mart {\n        width: 283px !important;\n        font-size: 14px !important;\n        margin-top: 10px;\n      }\n    }\n  }\n}\n\n// EDIT Mode - Filter Fields CSS\n#filtereditor-form-container {\n  .create-filter-form {\n    display: flex;\n    justify-content: flex-start;\n\n    >.filterFields.form-row {\n      margin: 10px 0px;\n      padding: 5px;\n      box-shadow:\n        4px 4px 10px #ebebeb,\n        -4px -4px 10px #eaeaeab5;\n      gap: 5px;\n      align-items: center;\n\n      .filterFieldsfilter-section-two {\n        flex: 1;\n        align-self: flex-end;\n\n        >.dashboard-filter-field {\n          flex: 1;\n        }\n\n        #value.dashboardTextField {\n          flex-basis: 0;\n        }\n\n        .dates-container {\n          display: inline-block;\n        }\n      }\n\n      .dash-manager-buttons {\n        display: flex;\n        align-items: flex-end;\n        margin-left: auto;\n        align-self: flex-end;\n      }\n    }\n  }\n}\n\ninput[type=\"checkbox\"] {\n  // transform: scale(1.5);\n  height: 12px;\n  width: 12px;\n}\n","//Variables for css styles to be defined here\n\n//Button styles\n$button-color: #345561;\n$button-background-color: #e4e7eb;\n$button-border-color: #c5d2d6;\n\n//Button styles on HOVER\n$button-background-color-hover: #c5d2d6;\n$button-border-color-hover: #c7cdd5;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
